export default "__VITE_PUBLIC_ASSET__5995e476__"